<mat-drawer #drawer [opened]="drawerOpened" class="responsive-drawer" mode="side"
            position="end">
  <!-- Drawer content -->
  <div cdkScrollable class="responsive-drawer-content" fxFlex fxLayout="column">
    <ng-container *ngTemplateOutlet="drawerContent"></ng-container>
  </div>
</mat-drawer>
